import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends, objectDestructuringEmpty as _objectDestructuringEmpty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Input } from 'antd';
import SearchOutlined from './../../../external/@ant-design/icons/es/icons/SearchOutlined.js';
import EyeOutlined from './../../../external/@ant-design/icons/es/icons/EyeOutlined.js';
import EyeInvisibleOutlined from './../../../external/@ant-design/icons/es/icons/EyeInvisibleOutlined.js';

var _excluded = ["type", "className"];
var types = {
  "password": "password",
  "search": "search"
};
var suffixSearch = function suffixSearch() {
  return /*#__PURE__*/React__default.createElement(SearchOutlined, {
    style: {
      fontSize: 16,
      color: 'var(--gray)'
    }
  });
};
var EyeOpen = function EyeOpen(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React__default.createElement(EyeOutlined, _extends({
    className: "dm-eye-icon-pass",
    style: {
      fontSize: 16,
      color: 'var(--gray)'
    }
  }, props));
};
// '#52b4ec'
var EyeClosed = function EyeClosed(_ref2) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return /*#__PURE__*/React__default.createElement(EyeInvisibleOutlined, _extends({
    className: "dm-eye-icon-pass",
    style: {
      fontSize: 16,
      color: '#bcbec6'
    }
  }, props));
};
/**
 * Primary UI component for user interaction
 */
var DmInput = function DmInput(_ref3) {
  var type = _ref3.type,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? "" : _ref3$className,
    props = _objectWithoutProperties(_ref3, _excluded);
  var getPassIcon = function getPassIcon(visible) {
    return visible ? /*#__PURE__*/React__default.createElement(EyeOpen, {
      style: {
        color: 'var(--sky-100)',
        fontSize: 16
      }
    }) : /*#__PURE__*/React__default.createElement(EyeClosed, null);
  };
  var renderComponent = function renderComponent(type, props) {
    switch (type) {
      case types.password:
        return /*#__PURE__*/React__default.createElement(Input.Password, _extends({
          className: "dm-input-password ".concat(className),
          iconRender: function iconRender(visible) {
            return getPassIcon(visible);
          },
          type: type
        }, props));
      case types.search:
        return /*#__PURE__*/React__default.createElement(Input, _extends({
          className: "dm-input-search ".concat(className),
          suffix: suffixSearch(),
          type: type
        }, props));
      default:
        return /*#__PURE__*/React__default.createElement(Input, _extends({
          className: "dm-input ".concat(className),
          type: type && type
        }, props));
    }
  };
  return renderComponent(type, _objectSpread2({}, props));
};
/**
 * In addition of custom datamart props, this input share all ant-design input props
 */
DmInput.defaultProps = {
  // type: LABEL_STATES.PENDING,
};

export { DmInput };
